//#region src/constants/AppLocales.ts
var e = ["en", "fr"];
//#endregion
export { e as t };

//# sourceMappingURL=AppLocales-BhP8HhaO.js.map